/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47846Item {
  
  /** 战役项目编号 */
  projectNo?: string;
  
  /** 战役项目名 */
  name?: string;
  
  /** 项目Logo */
  logo?: string;
  
  /** 项目级别1:超S级2:S级3:A级4:B级 */
  level?: number;
  
  /** 项目周期：1:成熟2:孵化3:筹备 */
  growStatus?: number;
  
  /** 负责人信息 ,UserResp */
  master?: any;
  
  /** 项目状态（1：正常；2：风险；3：失控） */
  status?: number;
  
  /** 项目进度 ,ProjectProgressResp */
  progress?: any;
  
  /** 当前里程碑 */
  milestone?: string;
  
  /** 里程碑截止日期 */
  milestoneTime?: any;
  
  /** 当前里程碑说明,(已过期N天) */
  milestoneTimeDesc?: string;
  
  /** 项目描述 */
  desc?: string;
  
  /** 项目负责人编号 */
  projectLeaderNo?: string;
  
  /** 项目负责人名称 */
  projectLeaderName?: string;
  
  /** 项目进度（61.23%存6123） */
  projectProgress?: number;
  
  /** 时间进度（61.23%存6123） */
  timeProgress?: number;
  
  /** 是否长期：0.非长期(默认)1.长期 */
  isLongTime?: number;
  
  /** 项目负责人真实名称 */
  projectLeaderRealName?: string;
  
  /** 项目负责人头像 */
  projectLeaderAvatar?: string;
  
};
    
  



export interface API47846Req {
  
  /** 项目id */
  projectNo?: string;
    
  /** 用户编号列表 */
  userNo?: string;
    
};



export interface API47846Res {
  /** 人员基础信息 ,ProjectTeamMemberResp  */
  baseInfo?: any;
  /** 参与的项目列表,todonixing ,ProjectInfoResp  */
  projectList?: API47846Item[];
  /** 是否有删除权限  */
  delete?: boolean;
  
};


// 47846 人员信息及参与项目查询

export interface IUseGetAPI47846Return {
  /** 人员信息及参与项目查询: 接口请求状态 */
  isAPI47846Loading: boolean;
  /** 人员信息及参与项目查询: 接口请求返回数据 */
  dataAPI47846: API47846Res;
  /**  人员信息及参与项目查询: 接口数据请求方法 */
  fetchAPI47846Data:  (inputs: API47846Req, config?: YWRequestConfig) => Promise<API47846Res>;
  /** 人员信息及参与项目查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47846 = ():IUseGetAPI47846Return => {
  let isMount = true;
  const [isAPI47846Loading, setIsAPI47846Loading] = useState(false);
  const [dataAPI47846, setDataAPI47846] = useState<API47846Res>({} as API47846Res);
  const requestUrl = `${basePath}/corp-admin/project/team/detail`;

  const fetchAPI47846Data = async (inputs: API47846Req, config?: YWRequestConfig): Promise<API47846Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47846Req>) || {}) as API47846Req;
    
  
    if ( isMount ) {
      setIsAPI47846Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47846Res>(`${basePath}/corp-admin/project/team/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47846(res || {} as API47846Res);
        setIsAPI47846Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47846Loading(false);
      }
      return false as unknown as API47846Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47846Loading,
    dataAPI47846,
    fetchAPI47846Data,
    requestUrl,
  }
}

